<template>
    <Dialog
        :visible="visible"
        @update:visible="(val) => emit('update:visible', val)"
        modal
        header="Terms & Conditions"
        class="h-[90vh] w-[90vw]"
    >
        <!-- Add loading state -->
        <div v-if="isLoading" class="flex justify-center items-center p-4">
            <ProgressSpinner />
        </div>

        <!-- Add error state -->
        <div v-if="error" class="text-red-500">{{ error }}</div>

        <!-- PDF viewer -->
        <div v-if="pdfUrl" class="pdf-container h-[90vh] w-[90vw]">
            <iframe
                :src="`${pdfUrl}#toolbar=0`"
                width="100%"
                height="100%"
                frameborder="0"
            ></iframe>
        </div>
    </Dialog>
</template>

<script setup>
import Dialog from 'primevue/dialog';
import ProgressSpinner from 'primevue/progressspinner';
import { defineProps, defineEmits, ref, watch } from 'vue';

const props = defineProps({
    visible: {
        type: Boolean,
        required: true
    },
    url: {
        type: String,
        required: true
    }
});

const emit = defineEmits(['update:visible']);

const isLoading = ref(false);
const error = ref(null);
const pdfUrl = ref(null);

const loadPDF = async () => {
    if (!props.url) return;
    
    try {
        isLoading.value = true;
        error.value = null;
        pdfUrl.value = props.url;
    } catch (err) {
        console.error('Error loading PDF:', err);
        error.value = 'Failed to load PDF';
    } finally {
        isLoading.value = false;
    }
};

// Watch for dialog visibility changes
watch(() => props.visible, (newVal) => {
    if (newVal) {
        loadPDF();
    } else {
        pdfUrl.value = null;
    }
});
</script>

<style scoped>
.pdf-container {
    margin-top: 1rem;
    border: 1px solid #ddd;
    border-radius: 4px;
}
</style>
